import React from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useBranding } from 'hooks/useBranding';
import { snakeCase } from 'lodash';
import { replaceBrandText } from 'utilities/lang';

import './styles.scss';

const TermAndPolicy = ({ className }) => {
  // Turn It Blue Digital LLC partners with Balance Payments to provide invoicing and payment processing. By submitting payment you agree to our terms of service and privacy policy.
    const { domainConfig } = useBranding();

  return (
    <div className={cn('t-center  fz-14 term-and-policy', className)}>
      <FormattedMessage
        id="term_and_policy.description"
        values={{
          domainName: (
            <FormattedMessage
              id={`header.${snakeCase(domainConfig.name)}`}
              defaultMessage={domainConfig.name}
            />
          ),
        }}
      />{' '}
      <a
        className="text-link action brand-color"
        target="_blank"
        href={replaceBrandText("https://www.turnitbluedigital.com/terms-of-service")}
      >
        <FormattedMessage id="term_and_policy.terms_of_service" />{' '}
      </a>
      <FormattedMessage id="common.and" />{' '}
      <a
        className="text-link action brand-color"
        target="_blank"
        href={replaceBrandText("https://www.turnitbluedigital.com/privacy")}
      >
        <FormattedMessage id="term_and_policy.privacy_policy" />
      </a>
    </div>
  );
};

export default TermAndPolicy;
